"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderText = exports.CardHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _wbmInputs = require("wbm-inputs");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var HeaderText = exports.HeaderText = function HeaderText(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var className = "page-header-text";
  if (props.className) {
    className += " " + props.className;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-weight-bold"
  }, props.text), props.qty ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "header-qty"
  }, "(", props.qty, " Items)") : null);
};
var CardHeader = exports.CardHeader = function CardHeader(_ref2) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  var className = "card-header-text font-weight-bold";
  if (props.className) {
    className += " " + props.className;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-weight-bold"
  }, props.text, props.linkText ? props.linkAddress ? /*#__PURE__*/_react["default"].createElement("a", {
    href: props.linkAddress,
    target: "_blank",
    className: "body wbm-button btn btn-link medium",
    rel: "noopener"
  }, props.linkText) : /*#__PURE__*/_react["default"].createElement(_wbmInputs.Button, {
    className: "wbm-button btn btn-link medium",
    onClick: props.onLinkClick
  }, props.linkText) : null));
};
//# sourceMappingURL=headerText.js.map